import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgControl } from '@angular/forms';
import { SoleBusiness, SoleBusinessService } from 'taxtank-core';
import { MatDialog } from '@angular/material/dialog';
import { SoleBusinessFormDialogComponent } from '@client/sole/components/sole-business-form-dialog/sole-business-form-dialog.component';
import { AbstractSelectComponent } from '@shared/component/form-controls/select/abstract-select/abstract-select.component';
import { Observable } from 'rxjs';

/**
 * Component with dropdown for sole business select
 */
@Component({
  selector: 'app-business-select',
  templateUrl: './business-select.component.html',
  styleUrls: ['./business-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BusinessSelectComponent extends AbstractSelectComponent<SoleBusiness> implements OnInit {
  @Input() emptyMessage = 'You haven\'t added any sole businesses yet.';
  @Input() emptyOptionLabel = 'All sole businesses';
  @Input() placeholder = 'Select Business';
  @Input() label = 'Select Business';
  @Input() tooltip: string;
  @Input() preselectFirst = true;

  dialogComponent = SoleBusinessFormDialogComponent;

  public ngControl = inject(NgControl);
  protected dialog = inject(MatDialog);
  private soleBusinessService = inject(SoleBusinessService);

  getOptions$(): Observable<SoleBusiness[]> {
    return this.soleBusinessService.getArray();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.getOptions$().subscribe(businesses => {
      if (!this.multiple && !this.value && this.preselectFirst) {
        this.ngControl.control.setValue(businesses[0], { emitEvent: false });
      }
    });
  }

  // compareOptions(optionValue: SoleBusiness | false, value: SoleBusiness | false): boolean {
  //   if (!optionValue && !value) {
  //     return true;
  //   }
  //
  //   return (optionValue as SoleBusiness).id === (value as SoleBusiness).id;
  // }
}
